import { VersionPicker } from "src/flowContainer/FlowAndVersionName";
import { RevisionHeader } from "src/flowContainer/RevisionHeader/RevisionHeader";
import { VersionAuthoringHeaderRightSideContent } from "src/flowContainer/VersionAuthoringHeaderRightSideContent";
import { LayoutHeader } from "src/layout/Header";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { getFlowVersionsUrl } from "src/router/urls";
import { SimulationHeader } from "src/simulations/SimulationHeader";

export const VersionAuthoringHeader = () => {
  const { orgId, workspace, flow, version, isRevision, simulationId } =
    useAuthoringContext();
  if (simulationId) {
    return (
      <SimulationHeader>
        <VersionAuthoringHeaderRightSideContent />
      </SimulationHeader>
    );
  }

  return (
    <LayoutHeader
      breadcrumbs={[
        {
          key: "flow-versions",
          breadcrumb: (
            <LayoutHeader.Breadcrumb
              dataLoc="back-to-versions"
              href={getFlowVersionsUrl(orgId, workspace.id, flow.id)}
              label={flow.name}
            />
          ),
        },
        {
          key: "flow-version",
          breadcrumb: (
            <LayoutHeader.Breadcrumb>
              {isRevision ? (
                <RevisionHeader changedBy={version.meta.updated_by_id} />
              ) : (
                <VersionPicker flow={flow} />
              )}
            </LayoutHeader.Breadcrumb>
          ),
        },
      ]}
      border
    >
      <VersionAuthoringHeaderRightSideContent />
    </LayoutHeader>
  );
};
